// Dependencies
import React, { Component } from 'react';

class PageTitleComponent extends Component {

  render() {

    return (
        <div>
            <div className="grid" style={{minHeight:"60px", alignItems:"center", background: "#0073AA", textAlign: "left"}}>
                <div className="col-1"></div>
                <div className="col-11" style={{paddingBottom: "15px", paddingTop: "15px"}}>
                    <span style={{color:"#FFFFFF", fontSize:"32px", fontWeight:"600"}}>{this.props.title}</span>
                </div>
            </div>
        </div>
    );
  }
}

export default (PageTitleComponent);